import { ITravelRequestPerson } from 'entities/Flights/sdk';

const AttendeeBox = ({ person }: { person: ITravelRequestPerson }) => {
  return (
    <div
      className={`min-h-[115px] w-[355px] p-[24px] bg-[url(src/assets/beige-background-box.png)] bg-cover max-sm:h-[115px] max-sm:max-w-[400px] max-sm:px-[16px] max-sm:bg-cover`}
    >
      <div className='font-[MuseoSansCyrl700] text-content-primary text-[24px] max-sm:text-[20px]'>
        {person.salutation} {person.first_name} {person.surname}
      </div>
      <div className='pt-[16px] font-[MuseoSansCyrl] text-content-secondary text-[14px]'>{person.date_of_birth}</div>
    </div>
  );
};

export default AttendeeBox;
